import widgets from '@/constants/telemetries/widgets'

const {
  DATA_TIME,
} = widgets

export default [
  DATA_TIME({}),
]